import { memo } from 'react';

import { GameCard, GameCardGame } from '@features/tournament/ui/components/GameCard';

import styles from './GamePreview.module.css';

export const GamePreview = memo(function GamePreview(props: GameCardGame) {
  return (
    <div className={styles.container}>
      <GameCard className={styles.gameCard} noShadow {...props} />
    </div>
  );
});
